import { combineReducers } from 'redux';
import { photoBookId, STATE_KEY as PHOTO_BOOK_ID_STATE_KEY } from './photoBookId';
import { context, STATE_KEY as CONTEXT_STATE_KEY } from './context';
import { folderId, STATE_KEY as FOLDER_STATE_KEY } from './folderId';
import { defaultText, STATE_KEY as TEXT_STATE_KEY } from './defaultText';
import { parentStyle, STATE_KEY as PARENT_STATE_KEY } from './parentStyle';

const bookProperties = combineReducers({
  [PHOTO_BOOK_ID_STATE_KEY]: photoBookId,
  [FOLDER_STATE_KEY]: folderId,
  [CONTEXT_STATE_KEY]: context,
  [TEXT_STATE_KEY]: defaultText,
  [PARENT_STATE_KEY]: parentStyle,
});

export default bookProperties;



// WEBPACK FOOTER //
// ./src/redux/reducers/bookproperties/index.js